<script setup lang="ts">
import { DispatchTemplate, Worldview } from "@/types/entity";

defineProps<{
  worldview: Worldview;
  templateList?: DispatchTemplate[];
}>();
</script>
<template>
  <div
    class="flex flex-col gap-2 border p-2 rounded cursor-pointer bg-base-100"
  >
    <div class="flex gap-2">
      <div class="aspect-square w-20 h-20 rounded-md overflow-hidden shrink-0">
        <VanImage
          class="w-full h-full"
          :src="worldview.media?.url ?? '/img/default-planet.gif'"
        />
      </div>
      <div class="flex flex-col gap-2 justify-between">
        <div class="flex flex-col gap-1">
          <div class="font-bold line-clamp-1">
            {{ worldview.name }}
          </div>
          <div
            class="line-clamp-3 text-xs"
            v-html="worldview.description"
          ></div>
        </div>
      </div>
    </div>
    <div
      v-if="templateList && templateList.length > 0"
      class="bg-base-200 border p-2 rounded text-xs"
    >
      <div v-for="(e, i) in templateList.slice(0, 3)" :key="e.id" class="">
        <span class="text-base-content/70 line-clamp-3 flex-1">
          {{ i + 1 }}. {{ e.name }}
        </span>
        <!-- <span
          class="text-base-content/70 line-clamp-3 flex-1"
          v-html="e.name"
        /> -->
      </div>
      <div v-if="templateList.length > 3">...</div>
    </div>
    <div
      v-if="templateList && templateList.length > 0"
      class="flex justify-end text-xs text-base-content/50"
    >
      <div>事件: {{ templateList.length }}</div>
    </div>
  </div>
</template>
